import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import {
    ChainSelectorModalProps,
    chainSelectorModalStyles,
} from './chain-selector-modal-helper';
import { DialogContent, Grid } from '@mui/material';
import { ChainSelector } from 'components/chain-selector/ChainSelector';

export const ChainSelectorModal = ({
    chainSelectorModal,
    chainSelectorModalTitle,
    chainSelectorModalSubheading,
    handleCancelButtonClick,
    handleNextButtonClick,
    handleCloseModal,
    selectedChain,
    setSelectedChain,
    selectChainFieldError,
    setSelectChainFieldError,
}: ChainSelectorModalProps): React.JSX.Element => {
    return (
        <Dialog
            closable={true}
            open={chainSelectorModal}
            onClose={handleCloseModal}
            title={chainSelectorModalTitle}
            sx={chainSelectorModalStyles.dialogStyles}
        >
            <DialogContent>
                <Grid>
                    <ChainSelector
                        selectedChain={selectedChain}
                        setSelectedChain={setSelectedChain}
                        text={chainSelectorModalSubheading}
                        error={selectChainFieldError}
                        setError={setSelectChainFieldError}
                        isImgHidden={false}
                        isDataCreated={true}
                    />
                </Grid>
                <Grid sx={chainSelectorModalStyles.buttonContainer}>
                    <Button
                        size='small'
                        variant='text'
                        color='grayscale'
                        onClick={handleCancelButtonClick}
                    >
                        Cancel
                    </Button>
                    <Button
                        size='small'
                        color='primary'
                        onClick={handleNextButtonClick}
                    >
                        Next
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
